import { useRouter } from 'expo-router'
import { Routes } from '@/src/common/enums/routes'
import { Button } from '@/src/common/components/Button'
import { useEffect } from 'react'
import { useSardine } from '@/src/services/Sardine'
import { View } from 'tamagui'
import * as Components from '../components'

export function CreditFrozenScreen() {
  const router = useRouter()
  const { updateOptions } = useSardine()

  useEffect(() => {
    void updateOptions({ flow: 'application-credit-frozen' })
  }, [updateOptions])

  return (
    <View flex={1} bg="$white1">
      <Components.ApplicationScreen>
        <View flex={1} px="$4">
          <Components.ApplicationScreen.Content title="Your Credit is Frozen">
            <Components.FormHelpText>
              It would seem as if we were unable to access your credit report. If you happen to have
              your profile frozen with any of the credit reporting bureaus, please unfreeze directly
              with the bureau then return here to proceed with your Mesa card application.
            </Components.FormHelpText>
          </Components.ApplicationScreen.Content>
        </View>
        <View px="$4" pb="$6" mt="$6">
          <Button title="Return Home" onPress={() => router.replace(Routes.Main.route)} />
        </View>
      </Components.ApplicationScreen>
    </View>
  )
}
